import { StyleSheet } from "aphrodite";

export const styles = StyleSheet.create({
  grid: {
    padding: "",
    margin: "0"
  },
  flexRow: {
    display: "flex",
    flexDirection: "column-reverse",
    marginTop: "-14px"
  },
  row: {
    paddingBottom: "13px"
  },
  headerDiv: {
    fontFamily: "roboto",
    fontWeight: "300",
    fontSize: "12px",
    display: "inline-block",
    marginRight: "15px"
  },
  headerSpan: {
    fontSize: "16px",
    fontWeight: "600"
  },
  buttonsWrap: {
    float: "right",
    width: "50%"
  },
  pdfButton: {
    float: "right",
    marginLeft: "4.76%",
    fontSize: "24px",
    color: "#fff",
    padding: "3px 4px",
    borderRadius: "0",
    backgroundColor: "#0b4687",
    marginTop: "13px"
  },
  pdfButtonSpan: {
    display: "inline-block",
    verticalAlign: "top",
    fontSize: "10px",
    textAlign: "left",
    lineHeight: "1em"
  },
  span: {
    background: "#f6f6f6",
    borderLeft: "1px solid #ccc",
    borderRight: "1px solid #ccc",
    display: "inline-block",
    verticalAlign: "middle",
    height: "25px",
    lineHeight: "25px",
    fontSize: "11px",
    fontFamily: "Roboto, sans-serif",
    padding: "0 .6em",
    cursor: "default"
  },
  inputsearch: {
    backgroundColor: "transparent !important",
    boxShadow: "transparent !important",
    border: "transparent !important",
    width: "100%",
    fontSize: "14px",
    outline: "none"
  },
  searchInputDiv: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#4E4E4E",
    padding: "15px",
    width: "30%",
    color: "#fff",
    marginTop: "-14px",
    boxShadow: "inset 0px 6px 15px -8px rgba(0,0,0,0.45)"
  },
  rightOptionsDiv: {
    display: "flex",
    flexDirection: "row",
    padding: "15px",
    marginTop: "-14px",
    backgroundColor: "#747474",
    boxShadow: "inset 0px 6px 15px -8px rgba(0,0,0,0.45)",
    color: "#fff",
    height: "52px",
    width: "100%",
    float: "left"
  },
  iconsMenu: {
    color: "#fff",
    fontSize: "20px",
    marginRight: "30px",
    cursor: "pointer"
  },
  disableIconsMenu: {
    color: "#afb4b9",
    fontSize: "20px",
    marginRight: "30px",
    pointerEvents: "none",
    cursor: "default"
  },
  imageiconsMenu: {
    width: "24px",
    cursor: "pointer",
    borderBottom: "2px solid transparent"
  },
  divFilter: {
    position: "absolute",
    right: "20px",
    zIndex: "999",
    backgroundColor: "#fff",
    padding: "20px",
    color: "#222222",
    minWidth: "290px",
    textAlign: "left",
    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.1) !important",
    marginTop: "13px"
  },
  divActivation: {
    marginBottom: "15px",
    margintop: "15px"
  },
  titleFilters: {
    fontSize: "12px",
    color: "#3f3f3f",
    marginBottom: "5px"
  },
  patientsDiv: {
    marginBottom: "5px",
    fontSize: "12px",
    color: "#3f3f3f"
  },
  radioFilter: {
    marginRight: "5px"
  },
  datePickerSpan: {
    background: "#f6f6f6",
    borderLeft: "1px solid #ccc",
    borderRight: "1px solid #ccc",
    display: "inline-block",
    verticalAlign: "middle",
    height: "36px",
    lineHeight: "38px",
    fontSize: "11px",
    fontFamily: "Roboto, sans-serif",
    padding: "0 .6em",
    cursor: "default"
  },
  buttonStyle: {
    color: "#fff",
    ":focus" : {
      boxShadow: "none"
    },
  },
  iconsDivStyle: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: 0,
  },
  tabsStyle: {
    height: "100%",
    backgroundColor: "#8991AF",
    color: "#FFF",
    borderColor: "#FFF",
    fontSize: "14px",
    textTransform: "uppercase",
    ":focus" : {
      boxShadow: "none"
    }
  },
  activatedStyle: {
    backgroundColor: "#518965",
  },
  deactivatedStyle: {
    backgroundColor: "rgb(145 76 76)",
  },
  pendingStyle: {
    backgroundColor: "rgb(148 136 85)",
  },
  cognitiveTypeStyle: {
    backgroundColor: "blue",
  },
});

